import { render, staticRenderFns } from "./BuildingDetailComponent.vue?vue&type=template&id=06b555ad&scoped=true"
import script from "./BuildingDetailComponent.vue?vue&type=script&lang=js"
export * from "./BuildingDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b555ad",
  null
  
)

export default component.exports